import {
    ApiBaseService,
    type ApiServiceConfig,
    type EnhancedFetch,
    type EnhancedFetchOptions,
    type PaginatedFetch,
    type PaginatedFetchOptions,
} from "./ApiBaseService";
import type { Process } from "~/models/Automation";
import type { ApiResponse } from "~/types/ApiResponse";

export default class AutomationProcessService extends ApiBaseService {
    private readonly uuid: string;

    constructor(uuid: string, config: ApiServiceConfig) {
        super(config);

        this.uuid = uuid;
    }

    public list(
        options?: Partial<PaginatedFetchOptions>,
    ): PaginatedFetch<Process[]> {
        return this.paginate<Process[]>(
            this.route(
                "api.automations.processes.index",
                "/automations/{automation}/processes",
                {
                    automation: this.uuid,
                },
            ),
            options as PaginatedFetchOptions,
        );
    }

    public find(
        id: number,
        options?: EnhancedFetchOptions,
    ): EnhancedFetch<Process> {
        return this.enhancedFetch<Process>(
            this.route(
                "api.automations.processes.show",
                "/automations/{automation}/processes/{process}",
                {
                    automation: this.uuid,
                    process: id,
                },
            ),
            options,
        );
    }

    public update(
        id: number,
        data: Partial<Process>,
    ): Promise<ApiResponse<Process>> {
        return this.request(
            this.route(
                "api.automations.processes.store",
                "/automations/{automation}/processes/{process}",
                {
                    automation: this.uuid,
                    process: id,
                },
            ),
            {
                method: "PATCH",
                body: data,
            },
        );
    }

    public delete(id: string): Promise<null> {
        return this.request(
            this.route(
                "api.automations.processes.destroy",
                "/automations/{automation}/processes/{process}",
                {
                    automation: this.uuid,
                    process: id,
                },
            ),
            {
                method: "DELETE",
            },
        );
    }
}
